// Here we store the query keys used by React Query

export enum ServerStateKeys {
    AccessAuthorizations = 'accessAuthorizations',
    AccountTransaction = 'AccountTransaction',
    AddMemberAssistant = 'AddMemberAssistant',
    AgendaDocument = 'agendaDocument',
    AgendaItem = 'agendaItem',
    AgendaTemplates = 'agendaTemplates',
    AggregatedMeetings = 'aggregatedMeetings',
    AllDocumentCopilotRagJob = 'allDocumentCopilotRagJob',
    AttachableTasks = 'attachableTasks',
    AttachableTasksAssignees = 'attachableTasksAssignees',
    AuthenticationStatus = 'AuthenticationStatus',
    AuthorizationToken = 'AuthorizationToken',
    BulkCreateAgendaItems = 'bulkCreateAgendaItems',
    CalendarFeed = 'calendarFeed',
    ContributionRequests = 'contributionRequests',
    CopilotSmartLiteJob = 'copilotSmartLiteJob',
    CopilotSmartLiteJobStatus = 'copilotSmartLiteJobStatus',
    CopyMeetingDocuments = 'copyMeetingDocuments',
    Csms = 'csms',
    DecisionStates = 'decisionStates',
    DeleteAgendaItem = 'deleteAgendaItem',
    DeleteMeetingDocument = 'deleteMeetingDocument',
    DigitalSignature = 'digitalSignature',
    Document = 'document',
    DocumentCopilotChatHistory = 'documentCopilotChatHistory',
    DocumentCopilotFeedback = 'documentCopilotFeedback',
    DocumentCopilotRagJob = 'documentCopilotRagJob',
    DocumentCopilotRagJobStatus = 'documentCopilotRagJobStatus',
    DocumentCopilotSettings = 'documentCopilotSettings',
    DocumentLabels = 'documentLabels',
    DocumentNotificationHistory = 'documentNotificationHistory',
    DocumentPreview = 'documentPreview',
    Documents = 'documents',
    DocumentsAggregated = 'documentsAggregated',
    DocumentsManageableGroups = 'documentsManageableGroups',
    DocumentsManageableMembers = 'documentsManageableMembers',
    DocumentsSearch = 'documentsSearch',
    DocusignSigningUrl = 'docusignSigningUrl',
    DownloadAllMeetingDocumentsPolling = 'downloadAllMeetingDocumentsPolling',
    DownloadFormXlsx = 'downloadFormXlsx',
    DownloadTopicHubCsv = 'downloadTopicHubCsv',
    EmailFeedback = 'emailFeedback',
    EncryptionKeysRemovalRequest = 'encryptionKeysRemovalRequest',
    EncryptionKeysRemovalRequests = 'encryptionKeysRemovalRequests',
    ExternalContent = 'externalContent',
    FeaturesRequested = 'featuresRequested',
    Flags = 'flags',
    Form = 'form',
    Forms = 'forms',
    GenerateMinutesEditorSections = 'generateMinutesEditorSections',
    GenerateMinutesPdf = 'generateMinutesPdf',
    GenerateSignatureRequest = 'generateSignatureRequest',
    GlobalSearch = 'globalSearch',
    Group = 'group',
    GroupManagersPicker = 'GroupManagersPicker',
    GroupMembersPicker = 'GroupMembersPicker',
    Groups = 'groups',
    GroupsList = 'groupsList',
    GuestInvitation = 'guestInvitation',
    Invitations = 'invitations',
    LastVisited = 'lastVisited',
    LatestAgendaItemMinutes = 'latestAgendaItemMinutes',
    Libraries = 'libraries',
    Library = 'library',
    LockUnlockMeeting = 'lockUnlockMeeting',
    LoggedUser = 'loggedUser',
    ManageableGroups = 'manageableGroups',
    ManageableMembers = 'manageableMembers',
    Meeting = 'meeting',
    MeetingAttendance = 'meetingAttendance',
    MeetingCheckInPreferences = 'meetingCheckInPreferences',
    MeetingComments = 'meetingComments',
    MeetingCommentsCount = 'meetingCommentsCount',
    MeetingDocument = 'meetingDocument',
    MeetingDocumentLabels = 'meetingDocumentLabels',
    MeetingDocuments = 'meetingDocuments',
    MeetingFeedbackAggregatedAnswers = 'meetingFeedbackAggregatedAnswers',
    MeetingFeedbackAnswers = 'meetingFeedbackAnswers',
    MeetingFeedbackQuestions = 'meetingFeedbackQuestions',
    MeetingHistory = 'meetingHistory',
    MeetingNote = 'meetingNote',
    MeetingNotificationHistory = 'meetingNotificationHistory',
    MeetingOutcomesSummary = 'meetingOutcomesSummary',
    MeetingOutcomesSummaryJobStatus = 'meetingOutcomesSummaryJobStatus',
    MeetingPreparednessSettings = 'meetingPreparednessSettings',
    MeetingState = 'meetingState',
    MeetingTranscript = 'meetingTranscript',
    MeetingTranscriptsList = 'meetingTranscriptsList',
    Meetings = 'meetings',
    MeetingsMembers = 'meetingsMembers',
    Member = 'member',
    MemberSecondFactorReset = 'memberSecondFactorReset',
    Members = 'members',
    MembersList = 'membersList',
    MentionableMembers = 'mentionableMembers',
    Minutes = 'minutes',
    MinutesCopilotJob = 'minutesCopilot',
    MinutesCopilotJobStatus = 'minutesCopilotJobStatus',
    MinutesCopilotOverview = 'minutesCopilotOverview',
    MinutesEditorSections = 'minutesEditorSections',
    MinutesEditorSectionsSorting = 'minutesEditorSectionsSorting',
    MinutesHistoryDetails = 'minutesHistoryDetails',
    MinutesHistoryList = 'minutesHistoryList',
    MinutesLayout = 'minutesLayout',
    MinutesPreview = 'minutesPreview',
    MtanEnrollmentRequest = 'MtanEnrollmentRequest',
    MtanEnrollmentSubmit = 'MtanEnrollmentSubmit',
    MtanRequest = 'MtanRequest',
    MtanSubmit = 'MtanSubmit',
    MultiCloneMeetingStatus = 'multiCloneMeetingStatus',
    NotificationPreferences = 'notificationPreferences',
    OnboardingInvitation = 'onboardingInvitation',
    OneTouchEnrollmentStatePolling = 'oneTouchEnrollmentStatePolling',
    OneTouchStatePolling = 'oneTouchStatePolling',
    OneTouchTransactionPolling = 'oneTouchTransactionPolling',
    Organisations = 'organisations',
    OverallMeetingPreparedness = 'overallMeetingPreparedness',
    Password = 'password',
    PermissionSets = 'permissionSets',
    PersonalMeetingPreparedness = 'personalMeetingPreparedness',
    ReorderAgendaItem = 'reorderAgendaItem',
    ReportsActionLogEntries = 'reportsActionLogEntries',
    ReportsActionLogOptions = 'reportsActionLogOptions',
    ReportsDashboard = 'reportsDashboard',
    ReportsDevicesList = 'reportsDevicesList',
    ReportsDevicesOptions = 'reportsDevicesOptions',
    ReportsFailedLogins = 'reportsFailedLogins',
    ReportsMembers = 'reportsMembers',
    ReportsMembersOptions = 'reportsMembersOptions',
    ReportsSuccessfulLogins = 'reportsSuccessfulLogins',
    ResetPassword = 'resetPassword',
    ResetRequest = 'resetRequest',
    RespondentForms = 'respondentForms',
    Room = 'room',
    RoomAdmin = 'roomAdmin',
    RoomSettings = 'roomSettings',
    Rooms = 'rooms',
    SSOMethod = 'SSOMethod',
    SalesUsers = 'salesUsers',
    SecondFactorStatus = 'SecondFactorStatus',
    SelectTemplate = 'selectTemplate',
    SingleDocumentCopilotRagJob = 'singleDocumentCopilotRagJob',
    SuggestedMembers = 'suggestedMembers',
    SupportAccessGrantees = 'supportAccessGrantees',
    SwitchAccount = 'switchAccount',
    TaskDecisionUpdate = 'taskDecisionUpdate',
    TasksAttachedToMeeting = 'tasksAttachedToMeeting',
    TasksDecisions = 'tasksDecisions',
    TasksDecisionsDownload = 'tasksDecisionsDownload',
    TasksDecisionsHistory = 'tasksDecisionsHistory',
    TasksDecisionsListAssignees = 'tasksDecisionsListAssignees',
    TasksDecisionsListMeetings = 'tasksDecisionsListMeetings',
    TasksStates = 'tasksStates',
    TeamsPreflight = 'teamsPreflight',
    TodoMeetings = 'todoMeetings',
    TopicCloneTargetRooms = 'topicCloneTargetRooms',
    TopicHub = 'topicHub',
    TopicHubAgendaItemDetails = 'topicHubAgendaItemDetails',
    TopicHubComments = 'topicHubComments',
    TopicHubDocumentPreview = 'topicHubDocumentPreview',
    TopicHubDocuments = 'topicHubDocuments',
    TopicHubDownload = 'topicHubDownload',
    TopicHubMeetingOutcomes = 'topicHubMeetingOutcomes',
    TopicHubMeetings = 'topicHubMeetings',
    TopicHubRequest = 'topicHubRequest',
    TopicHubRequesters = 'topicHubRequesters',
    TopicHubTopicDetails = 'topicHubTopicDetails',
    TotpSubmit = 'TotpSubmit',
    TranslationCopilotJob = 'translationCopilotJob',
    TranslationCopilotJobStatus = 'translationCopilotJobStatus',
    UploadDebugRequests = 'uploadDebugRequests',
    UserStates = 'userStates',
    ValidateEmail = 'validateEmail'
}
